import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Switch } from "react-router-dom";

import { PrivateRoute } from "helper/route";

// pages
import RiskAssessment from "pages/JarvisPrime/PrimeOnboarding/PrimeRiskAssessment";
import InvestmentPreference from "pages/JarvisPrime/PrimeOnboarding/PrimeInvestmentPreference";
import PrimeCreation from "pages/JarvisPrime/PrimeOnboarding/PrimeCreation";
import CKYC from "pages/JarvisPrime/PrimeOnboarding/PrimeCKYC";
import ChooseBroker from "pages/JarvisPrime/PrimeOnboarding/PrimeChooseBroker";
import Overview from "pages/JarvisPrime/PrimeOnboarding/Overview";
import OnboardingPrimeLayout from "containers/Onboarding/OnboardingPrimeLayout/index";

const JarvisPrimeOnboardingNavigator = (props) => {
  const { match } = props;
  const auth = useSelector((state) => state.customer);

  return (
    <Switch>
      {/* <Redirect exact from={match.path} to={`${match.path}`} /> */}
      <OnboardingPrimeLayout {...props}>
        <Switch>
          <PrivateRoute
            exact
            auth={auth}
            path={`${match.path}/overview`}
            component={Overview}
          />

          <PrivateRoute
            exact
            auth={auth}
            path={`${match.path}/risk-assessment`}
            component={RiskAssessment}
          />

          <PrivateRoute
            exact
            auth={auth}
            path={`${match.path}/investment-preference`}
            component={InvestmentPreference}
          />

          <PrivateRoute
            exact
            auth={auth}
            path={`${match.path}/prime-creation`}
            component={PrimeCreation}
          />

          <PrivateRoute
            exact
            auth={auth}
            path={`${match.path}/ckyc`}
            component={CKYC}
          />

          <PrivateRoute
            exact
            auth={auth}
            path={`${match.path}/choose-broker`}
            component={ChooseBroker}
          />
        </Switch>
      </OnboardingPrimeLayout>
      <Redirect to={`not-found`} />
    </Switch>
  );
};

export default JarvisPrimeOnboardingNavigator;
